// React
import React from "react";
import { useNavigate } from "react-router-dom";

// Material UI
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import ToolTip from "../../../../Components/Interactive/ToolTip";
import WarningSharpIcon from '@mui/icons-material/WarningSharp';

// Helper Functions
import { formatDate } from "../../../../Helpers/formatters";

// Icons
import BrandIcon from "../../../../Utilities/BrandIcon";
import CardIcon from "../../../../Utilities/CardIcon";

const renderTable = (navigate, orderResults, page, rowsPerPage) => {
  return (
    orderResults &&
    orderResults.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map(({brand, customerId, customerName, campaignName, scn, orderTotal, orderStatus, orderId, ipAddress, orderDate, isCustomerActive, bank, cardType, customerEmail}, index) => {
      if (brand === "Kids Live Safe") brand = "KLS";
      if (brand === "Public Data Check") brand = "PDC";
      if (brand === "SpyFly") brand = "SF";
      if (brand === "Public Info Services") brand = "PIS";
      if (brand === "Search Public Records") brand = "SPR";
      if (brand === "Public Record Reports") brand = "PRR";
      if (brand === "Quick Public Records") brand = "QPR";
      if (brand === "Property Focus") brand = "PF";

      const brandIds = {
        KLS: 1,
        SF: 2,
        PDC: 3,
        PIS: 4,
        SPR: 5,
        PRR: 6,
        QPR: 7,
        PF: 8,
      };

      return (
        <TableRow
          key={index}
          onClick={() => navigate(`/Customer/${customerId}`)}
          className="order-row"
        >
          <TableCell className="tableCell" align="center">
            {customerName}
            {!isCustomerActive &&
              <>
                <ToolTip placement="left" titleHeading="Inactive Customer">
                <span> <WarningSharpIcon sx={{ color: 'red !important', size: '8px', marginBottom: '-5px' }} /></span>
                </ToolTip>
              </>
            }
          </TableCell>
          <TableCell className="tableCell" align="center">
            <BrandIcon brandId={brandIds[brand]} />
          </TableCell>
          <TableCell className="tableCell" align="center">
            {campaignName}
          </TableCell>
          <TableCell className="tableCell" align="center">
            {scn}
          </TableCell>
          <TableCell className="tableCell" align="center">
            {orderTotal}
          </TableCell>
          <TableCell className="tableCell" align="center">
            {orderStatus}
          </TableCell>
          <TableCell className="tableCell" align="center">
            {customerId}
          </TableCell>
          <TableCell className="tableCell" align="center">
            {orderId}
          </TableCell>
          <TableCell className="tableCell" align="center">
            {ipAddress}
          </TableCell>
          <TableCell className="tableCell" align="center">
            {bank}
          </TableCell>
          <TableCell className="tableCell" align="center">
            <CardIcon cardType={cardType} isSmallLogo={true} />
          </TableCell>
          <TableCell className="tableCell" align="center">
            {customerEmail}
          </TableCell>
          <TableCell className="tableCell" align="center">
            {formatDate(orderDate)}
          </TableCell>
        </TableRow>
      );
    })
  );
};

const OrderSearchBody = ({ orderResults, page, rowsPerPage }) => {
  const navigate = useNavigate();
  return (
    orderResults &&
    orderResults.length > 0 && (
      <TableBody>{renderTable(navigate, orderResults, page, rowsPerPage)}</TableBody>
    )
  );
};

export default OrderSearchBody;
